import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FlexBox } from '../../box';
export const DataGridCell = React.forwardRef((props, ref) => {
    return (_jsx(FlexBox
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
    , { 
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
        ref: ref, height: "100%", vAlign: "center", stretch: true, ...props }));
});
